import styled from "styled-components";

export const CardContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  max-width: 1000px;
  margin: auto;

  @media (max-width: 800px) {
    grid-template-columns: repeat(3, 1fr);
    width: 100%;
  }

  @media (max-width: 700px) {
    width: 90%;
    grid-template-columns: 1fr;
  }
`;

export const Card = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px;
  margin: auto;
  cursor: pointer;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;
